<div class="container">
  <hr class="divider" />
  <strong class="appname">{{ appName }}</strong>
  <hr class="divider" />
</div>
